// extracted by mini-css-extract-plugin
module.exports = {"container":"_93444fe79c--container--NUnQW","banner":"_93444fe79c--banner--MWssZ","text":"_93444fe79c--text--gtss8"};